import * as React from "react";
import PropTypes from 'prop-types';
import { useRecordContext } from 'react-admin';

export const DateField = (props) => {
  const { source } = props;
  const record = useRecordContext(props);

  if (record[source]) {
    let date = record[source].split('-');
    return <label>{`${date[2]}/${date[1]}/${date[0]}`}</label>;
  }

  return <label>Não definido</label>;
};

DateField.propTypes = {
  record: PropTypes.object,
};